import script from "./Siding13Paint.vue?vue&type=script&setup=true&lang=js"
export * from "./Siding13Paint.vue?vue&type=script&setup=true&lang=js"

const __exports__ = script;

export default __exports__